/**
 * P0 の空と光：縦のグラデーションの空、太陽光、霞。
 * 大気散乱の空と時刻による変化は P4（docs/05_rendering-and-audio.md 4 章）。
 */
import * as THREE from 'three';

const HORIZON = new THREE.Color(0xc9d9e8);
const ZENITH = new THREE.Color(0x4f7fb8);

export interface SkyAndLight {
  sun: THREE.DirectionalLight;
  update(camera: THREE.Camera): void;
}

export function createSkyAndLight(scene: THREE.Scene): SkyAndLight {
  scene.fog = new THREE.FogExp2(HORIZON.getHex(), 0.0000115);
  scene.background = HORIZON.clone();

  const dome = new THREE.Mesh(
    new THREE.SphereGeometry(400_000, 32, 16),
    new THREE.ShaderMaterial({
      side: THREE.BackSide,
      depthWrite: false,
      depthTest: false,
      fog: false,
      uniforms: { horizon: { value: HORIZON }, zenith: { value: ZENITH } },
      vertexShader: /* glsl */ `
        varying vec3 vDir;
        void main() {
          vDir = normalize(position);
          gl_Position = projectionMatrix * modelViewMatrix * vec4(position, 1.0);
        }`,
      fragmentShader: /* glsl */ `
        uniform vec3 horizon;
        uniform vec3 zenith;
        varying vec3 vDir;
        void main() {
          float t = pow(clamp(vDir.y, 0.0, 1.0), 0.45);
          gl_FragColor = vec4(mix(horizon, zenith, t), 1.0);
          #include <colorspace_fragment>
        }`,
    }),
  );
  dome.renderOrder = -100;
  dome.frustumCulled = false;
  scene.add(dome);

  // 午前 10 時ごろの南東の太陽
  const sun = new THREE.DirectionalLight(0xfff2dd, 2.6);
  sun.position.set(0.55, 0.75, 0.45).multiplyScalar(100_000);
  scene.add(sun, sun.target);
  scene.add(new THREE.HemisphereLight(0xcfe3ff, 0x5a5040, 0.9));

  return {
    sun,
    update(camera) {
      dome.position.copy(camera.position);
    },
  };
}
